/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_YearInputs */

const en_case_field_year = /** @type {(inputs: Case_Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year`)
};

const pt_br2_case_field_year = /** @type {(inputs: Case_Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano`)
};

/**
* | output |
* | --- |
* | "Year" |
*
* @param {Case_Field_YearInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_year = /** @type {((inputs?: Case_Field_YearInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_YearInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_year(inputs)
	return pt_br2_case_field_year(inputs)
});